export default {
  screens: [
    {
      type: 'intro',
      title: '自然',
      content:
        '尽きることのないインスピレーションの源である豊かで象徴的な自然は、メゾンの歴史の中で常に主要なテーマとなってきました。',
      idYt: 'GUF98BCNd3c',
      videoCover: 'world/wild/video.jpg',
      desktop: {
        cover: 'world/wild/cover-1.jpg'
      },
      mobile: {
        cover: 'world/wild/mobile-cover-1.jpg',
        contentStyle: { width: '100%', paddingBottom: '120px' },
        coverStyle: {
          width: '110%',
          top: '87%',
          bottom: '40px',
          left: '0',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/wild/memento.jpg',
      content:
        ' 職人の巧みな手によって宝石に姿を変えた動物、植物、昆虫は、野生の自然、生き生きとした自然、はかない自然を語ります。<br><br> 様々な文化的意味が込められたショーメの自然主義は、格式高いジュエリーを生み出しました。',
      cover: 'world/wild/cover-2.jpg',
      isCover: true
    },
    {
      type: 'staircase',
      desktop: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/cover-3.jpg'
      },
      mobile: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/mobile-cover-3.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '85%',
          top: '5%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '皇后ジョゼフィーヌのお気に入りでもあった豊穣を象徴する麦の穂は、昔から風にそよいでいるかのようです。<br><br> ショーメは、1811年に作られた「麦の穂」のティアラから得たこのモチーフに、たえず新たな解釈をもたらしてきました。',
      cover: 'world/wild/cover-3.jpg',
      isCover: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/wild.js